export const ROUTE_PATH = {
  ERROR_PAGE: '/404',
  AUTH: '/auth',
  RESTORE_CONFIRM: '/auth/restore/confirm',
  RESTORE_AUTH: '/auth/restore/recovery',
  MAIN: '/',
  MARATHON_LANDING: '/parents-marathon',
  MARATHON_DIAGNOSTICS: '/diagnostics-marathon',
  MARATHON_SPEECH: '/speech-marathon',
  REGISTER: '/register',
  EXPIRED: '/expired',
  RESTORE_PAGE: '/auth/restore',
  REGISTER_VERIFICATION: '/register/verification',
  REGISTER_CONFIRM: '/register/confirm',
  MATERIALS_EARLY: '/materials/early',
  MATERIALS_PRESCHOOL: '/materials/preschool',
  MATERIALS_DETAIL: '/materials/detail',
  MATERIALS_DETAIL_GAME: '/materials/detail/parentTheme/:parentTheme',
  MAIN_VIDEO: '/video',
  PRIVACY_POLICY: '/privacy-policy',
  USER_AGREEMENT: '/user-agreement',

  GAMES_LIST: '/materials/detail/games-list/:gameCategory',
  CURRENT_GAME: '/materials/detail/games-list/:gameCategory/age/:age/selectedMaterial/:selectedMaterial/game/:currentGame',

  CURRENT_CARD: '/training-cards/card/:currentCard',

  KINDERGARTEN_LIST: '/kindergarten-list',

  ARTICLES: '/articles',
  ARTICLES_AUTHORS: '/authors/:authorId',
  ARTICLES_DETAILS: '/articles/:articleId',
  
  PSYCHO_PED_SUPPORT: '/psycho-ped-support',
  CURRENT_PSYCHO: '/psycho-ped-support/type/:type/supportId/:supportId',
  CURRENT_PSYCHO_DETAIL: '/psycho-ped-support/type/:type/supportId/:supportId/category/:categoryId',

  SCREENING: '/screening',
  SCREENING_TESTS_LIST: '/screening/tests-list',
  SCREENING_CURRENT_TEST: '/screening/tests-list/:testId',
  SCREENING_CURRENT_TEST_WITH_AGE: '/screening/tests-list/:testId/age/:ageId/name/:name/childId/:childId',
  SCREENING_CURRENT_TEST_WITH_AGE_PROCESSING: '/screening/tests-list/:testId/age/:ageId/name/:name/childId/:childId/processing',
  SCREENING_QUESTIONNAIRE_YOURSELF: '/screening/questionnaire_yourself',
  SCREENING_WITH_SPECIALIST: '/screening/with_specialist',
  
  SCREENING_READINESS: '/screening/readiness',
  SCREENING_READINESS_TESTS_LIST: '/screening/readiness/tests-list',
  SCREENING_READINESS_CURRENT_TEST: '/screening/readiness/tests-list/:testId',
  SCREENING_READINESS_CURRENT_TEST_WITH_AGE: '/screening/readiness/tests-list/:testId/age/:ageId/name/:name/childId/:childId',
  SCREENING_READINESS_CURRENT_TEST_WITH_AGE_PROCESSING: '/screening/readiness/tests-list/:testId/age/:ageId/name/:name/childId/:childId/processing',

  SCREENING_NEURO: '/screening/neuropsychology',
  SCREENING_CURRENT_NEURO: '/screening/neuropsychology/:testId',
  SCREENING_CURRENT_NEURO_WITH_AGE: '/screening/neuropsychology/:testId/age/:ageId/name/:name/childId/:childId',
  SCREENING_CURRENT_NEURO_WITH_AGE_PROCESSING: '/screening/neuropsychology/:testId/age/:ageId/name/:name/childId/:childId/processing',



  SCREENING_TESTS_LIST_EARLY: '/screening/with_specialist',
  SCREENING_CURRENT_TEST_EARLY: '/screening/with_specialist/:testId',
  SCREENING_CURRENT_TEST_EARLY_WITH_AGE: '/screening/with_specialist/:testId/age/:ageId/name/:name/childId/:childId',
  SCREENING_CURRENT_TEST_EARLY_WITH_AGE_PROCESSING: '/screening/with_specialist/:testId/age/:ageId/name/:name/childId/:childId/processing',
  SCREENING_QUESTIONNAIRE_YOURSELF_EARLY: '/screening/questionnaire_yourself',
  SCREENING_WITH_SPECIALIST_EARLY: '/screening/with_specialist',


  SPECIALISTS: '/specialists',
  PROFILE: '/profile',
  MY_CONSULTATIONS: '/my-consultations',
  RESULTS: '/results/testId/:testId/type/:type',
  RESULTS_CONSULTATION: '/results/consultation/testId/:testId/type/:type',

  TRAINING_CARDS: '/training-cards',
  AUDIO_TALES: '/audio-tales',


} as const
